import type { ServiceType } from 'types';
import { baseQuery } from '../baseQuery';

type VerifyAvailabilityProps = {
  technicianId: number;
  startDate: string;
  serviceSelectionId: number;
  serviceType: ServiceType;
};

export const getVerifyTechnicianAvailability = async ({
  technicianId,
  startDate,
  serviceSelectionId,
  serviceType,
}: VerifyAvailabilityProps) => {
  const data = await baseQuery(
    `technicians/${technicianId}/verify-availability?appointment_start=${startDate}&service_selection_id=${serviceSelectionId}&service_type=${serviceType}`,
  );

  return data;
};
